import * as React from 'react';
import { useState, useEffect, useMemo, useRef } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import {Box, Divider, IconButton, Typography, FormControl, InputLabel, Select, MenuItem, TableContainer, ButtonGroup, Paper} from '@mui/material';
import { printVariable } from '@util/helper';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import { useMediaQuery, useTheme } from "@mui/material";
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import useAlert from "@hooks/useAlert";
import moment from 'moment';
import Tab from "@mui/material/Tab"
import TabList from "@mui/lab/TabList"
import TabContext from "@mui/lab/TabContext"
import TabPanel from "@mui/lab/TabPanel"

import MUITable from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableFooter from "@mui/material/TableFooter"
import MyTableHead from '@components/MyTableHead';
import * as ExcelJS from 'exceljs'
import ControlPoint from '@mui/icons-material/ControlPoint';

const dayMap = {
  'S001': '월',
  'S002': '화',
  'S003': '수',
  'S004': '목',
  'S005': '금',
  'S006': '토',
  'S007': '일',
}
const statCodeMap = {
  S000: " ",
  S001: "○",
  S200: "X1",
  S201: "X2",
  S202: "X3",
  S203: "X4",
  S204: "X5",
  S205: "X6",
  S206: "X7",
  S003: "△",
  S004: "◐",
  H001: "D",
  H002: "H",
  X001: "-",
  X002: "ⓧ",
}

// const offCodeMap = {
//   F000: "미정",
//   F001: "보호자 동행",
//   F002: "대리인 동행",
//   F003: "학원차 이용",
//   F004: "자율귀가",
// }s
const greyBg = {
  type: 'pattern',
  pattern: 'solid',
  fgColor: { argb: 'f5f5f5' },
  bgColor: { argb: 'f5f5f5' }
}


const ALL = '전체'
const iFormat= 'YYYY-MM-DD HH:mm:ss';
const oFormat= 'MM-DD';
const defSmst = {id:-1, year:'', gisu: ''}

const TeacherAttdncPartMany = ({dialogHandler, smst, choice }) =>  {
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const schola = useSelector(state => state.scholaReducer)
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const {alert, renderAlert} = useAlert()
  const contentRef = useRef(null)
  const codes = useSelector(state => state.codeReducer)

  const offCodeMap = Object.fromEntries(
    codes.filter(r => r.codeGroupId === 'SA29').map(r => [r.code, r.name])
  )
  const getHeadRow = (lectureId) => {
    const row =[" No. ", " 학년 ", " 반 ", " 번호 ", "  이름  ", "보호자전화번호 ", " 귀가방법 ", "비고"]
    let attdncs = smst.lectures.find(l => l.id === lectureId)?.attdncs

    if(choice.period === 1) {
      attdncs = attdncs.filter(r => {
        const yyyymm = moment(r.lectureTime, iFormat).format('YYYY-MM')
        return yyyymm === choice.month
      })
    }
    else if(choice.period === 2) {
      /*
      attdncs = attdncs.filter(r => {
        const yyyymmdd = moment(r.lectureTime, iFormat).format('YYYY-MM-DD')
        return yyyymmdd === choice.targetDate
      })
      */
      attdncs = attdncs.filter(r => {
        const dt = moment(r.lectureTime, iFormat)
        const from = moment(choice.targetDate, 'YYYY-MM-DD')
        const to = moment(choice.targetDate2, 'YYYY-MM-DD')
        return dt.isBetween(from, to, 'day', '[]' )
      })

    }

    attdncs.forEach((a, idx) => {
      let mmdd = moment(a.lectureTime, iFormat).format(oFormat)
      if(a.subLectureTime) {
        mmdd = '(취)'+mmdd + ' (보)' + moment(a.subLectureTime,iFormat).format(oFormat) + ' ' + a.subStartTime + '~' + a.subEndTime
      }
      row.push(mmdd)
    })

    if(attdncs.length > 0) {
      return row
    }
    else {
      return null
    }
  }

  const getDataRows = (lectureId) => {
    const lecture = smst.lectures.find(l => l.id === lectureId)
    let students = lecture?.students
    if(choice.grade !== ALL)  {
      students = students.filter(s => +s.grade === +choice.grade)
    }
    if(choice.className !== ALL) {
      students = students.filter(s => s.className === choice.className)
    }

    let attdncs = lecture?.attdncs
    if(choice.period === 1) {
      attdncs = attdncs.filter(r => {
        const yyyymm = moment(r.lectureTime, iFormat).format('YYYY-MM')
        return yyyymm === choice.month
      })
    }
    else if(choice.period === 2) {
      /*
      attdncs = attdncs.filter(r => {
        const dt = moment(r.lectureTime, iFormat).format('YYYY-MM-DD')
        const yyyymmdd = moment(r.lectureTime, iFormat).format('YYYY-MM-DD')
        return yyyymmdd === choice.targetDate
      })
      */

      attdncs = attdncs.filter(r => {
        const dt = moment(r.lectureTime, iFormat)
        const from = moment(choice.targetDate, 'YYYY-MM-DD')
        const to = moment(choice.targetDate2, 'YYYY-MM-DD')
        return dt.isBetween(from, to, 'day', '[]' )
      })
    }

    const bings = lecture?.bings
    const rows = []
    students.forEach((student, idx) => {
      const phone = choice.hidePhone ? 'XXXXXXXXXXX' : student.gdnPhone
      const row = [idx+1, student.grade, student.className, student.classNum, student.name, phone, offCodeMap[student.regi?.offCode], '']
      attdncs.forEach((attdnc, idx2) => {
        const bing = bings.find(r => r.studentId == student.id && r.attdncId === attdnc.id)
        if(bing) {
          row.push(statCodeMap[bing.statCode])
        }
      })
      rows.push(row)
    })

    //빈 공간 채워주기
    if(choice.fillEmpty) {
      const diff = lecture?.rcrNum ? lecture?.rcrNum - rows.length : 0
      if(diff > 0) {
        let nextRowNum = rows.length  + 1
        while(nextRowNum <= lecture?.rcrNum) {
          const row = [nextRowNum, '', '', '', '', '', '']
          attdncs.forEach((attdnc, idx2) => {
            row.push('')
          })

          rows.push(row)
          nextRowNum  = nextRowNum + 1
        }
      }
    }
    return rows
  }

  const tabs = React.useMemo(() => {
    const tabArray = []
    let tidx = 1
    smst.lectures.forEach((lecture, idx) => {
      const headRow = getHeadRow(lecture.id)
      const dataRows = getDataRows(lecture.id)
      if(headRow && dataRows.length > 0) {
        const tab = {
          label: `${tidx}.${lecture.title}`,
          value: lecture.id
        }
        tidx = tidx + 1
        tabArray.push(tab)
      }
    })
    return tabArray
  },[smst])

  const [tabValue, set_tabValue] = tabs.length > 0 ? useState(tabs[0].value) : useState('')

  const getHeaderText = (lectureId) => {
    const left = `${schola.name} ${smst.year}년 ${smst.gisu}기`
    const center = `늘봄 학교 출석부`
    const lecture = smst.lectures.find(l => l.id === lectureId)
    const right = `${lecture.title} ${lecture.teacher.name} ${lecture.schedule}`

    return {
      left: left,
      center: center,
      right: right
    }
  }




  const handleClose = (event, reason)=> {
    if(reason && reason === "backdropClick") {
      return
    }
    else {
      dialogHandler[1](false)
    }
  }

  const handleTabChange = (event, newValue) => {
    set_tabValue(newValue)
    contentRef.current.scrollTop = 0
  }

  const downloadTmpl = async (sign) => {
    const url = `/attdnc/download/tmpl/${sign}`
    const response = await axios.get(url, { responseType: 'arraybuffer' })
    const buffer = response.data
    return buffer
  }

  const onDownload = async(sign) => {
    const buffer = await downloadTmpl(sign)
    const workbook = new ExcelJS.Workbook()
    await workbook.xlsx.load(new Uint8Array(buffer))

    const lectures = []
    let dataRowsMap = {}

    smst.lectures.forEach(lecture => {
      const headRow = getHeadRow(lecture.id)
      const dataRows = getDataRows(lecture.id)
      if(headRow && dataRows.length > 0) {
        dataRowsMap[''+lecture.id] = dataRows
        lectures.push(lecture)
      }
    })

    const firstSheet = workbook.getWorksheet(1)
    const regex = /[*?:\\\/[\]]/g

    lectures.forEach((lecture, idx) => {
      // const sheet = workbook.addWorksheet(lecture.title)
      const sheetName = `${idx+1}.${lecture.title}`.replace(regex, '_')
      const sheet = workbook.addWorksheet(sheetName)

      // Copy header and footer
      sheet.headerFooter = Object.assign({}, firstSheet.headerFooter);

      // Copy other sheet properties (adjust as needed)
      sheet.properties.defaultRowHeight = firstSheet.properties.defaultRowHeight;

      // Copy page layout information
      sheet.pageSetup = Object.assign({}, firstSheet.pageSetup);
      sheet.pageLayout = true
      sheet.views = [
        {
          state: 'normal',
          zoomScale: 80,
          zoomScaleNormal: 80,
          style: 'pageLayout',
        },
      ];

      // remove rows
      for (let i = sheet.rowCount; i > 0; i--) {
        sheet.spliceRows(i, 1);
      }

      // set header
      const headerText = getHeaderText(lecture.id)

      const header = sheet.headerFooter.oddHeader
      let mtext= header
      mtext = mtext.replace('@LEFT', headerText.left )
      mtext = mtext.replace('@CENTER', headerText.center)
      mtext = mtext.replace('@RIGHT', headerText.right)
      //
      // sheet.headerFooter.firstHeader= mtext
      // sheet.headerFooter.oddHeader= mtext
      sheet.headerFooter.oddHeader= mtext
      sheet.headerFooter.evenHeader= mtext

      const headRow = getHeadRow(lecture.id)

      // head row
      const excelRow = sheet.addRow(headRow)
      excelRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.font = {
          name:'맑은 고딕',
          bold: true
        }
        cell.alignment={horizontal:'center'}
      });
      excelRow.getCell(1).fill = greyBg

      // data row
      const dataRows = dataRowsMap[''+lecture.id]
      dataRows.forEach(row => {
        const excelRow = sheet.addRow(row)
        excelRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
          cell.font = {
            name:'맑은 고딕',
            size:10,
          }
          cell.alignment={horizontal:'center'}
        });
        excelRow.getCell(1).fill = greyBg
      })

      sheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
        row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
          cell.border = {
            top: {style:'thin'},
            left: {style:'thin'},
            bottom: {style:'thin'},
            right: {style:'thin'}
          }
        })
      })
      // fix col width
      sheet.columns.forEach((column, colNumber) => {
        if(colNumber == 0 || colNumber === 1 || colNumber === 2 || colNumber === 3) {
          column.width = 5
        }
        else if(colNumber === 4) { // 이름
          column.width = 9
        }
        else if(colNumber === 5) {  // 전화번호
          column.width = 15
        }
        else if(colNumber === 6) {  // 귀가방법
          column.width = 9
        }
        else {
          let subExists = false
          column.eachCell({ includeEmpty: true }, (cell, rowNumber) => {
            const cellValueLength = cell.value ? String(cell.value).length : 0
            if(cellValueLength > 7) {
              subExists = true
            }
          })
          if(subExists) {
            column.width = 35
          }
          else {
            column.width = 7
          }

        }
     })
    })

    // make it download
    workbook.removeWorksheet(1)
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      let filename = `${schola.name}_${smst.year}년${smst.gisu}기_`
      if(choice.period === 0) {
        filename = filename + `${ALL}기간`
      }
      if(choice.period === 1)  {
        filename = filename + `${choice.month}월`
      }
      if(choice.period === 2)  {
        filename = filename + `${choice.targetDate}~${choice.targetDate2}일`
      }
      filename = filename + `_${choice.grade}학년_${choice.className}반.xlsx`
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    });

  }

  const onLoad = async() => {
  }

  useEffect(() => {
    onLoad()
  }, [])

  return (
    <Fragment>
      <Dialog open={dialogHandler[0]} onClose={handleClose} maxWidth='xl' fullWidth disableScrollLock>
        <DialogTitle>
          <Typography variant='h5' align='center'>
            {schola.name}
          </Typography>
          <Typography variant='body2' >
            출석부 옵션: <br/>{smst.year}/{smst.gisu}기수,
            {choice.period === 0 ?  ALL + '기간' : null}
            {choice.period === 1 ?  choice.month + '월': null}
            {choice.period === 2 ?  choice.targetDate +'~' + choice.targetDate2 + '일': null}
            ,{choice.grade}학년, {choice.className}반
          </Typography>
          <Divider />
        </DialogTitle>
        <DialogContent ref={contentRef}>
          <TabContext value={tabValue}>
            <Box sx={{ borderBottom: 1, borderColor: "divider", position: "sticky", top: 0, backgroundColor: "#fff", overflowX:'auto' }}>
              <TabList onChange={handleTabChange} aria-label='lab API tabs example' scrollButtons="auto" variant='scrollable'>
                {
                  tabs.map((tab, idx) => (
                    <Tab key={idx} label={tab.label} value={tab.value} />
                  ))
                }
              </TabList>
            </Box>

            {
              tabs.map((tab, idx) => {
                const headerText = getHeaderText(tab.value)
                const headRow = getHeadRow(tab.value)
                const dataRows = getDataRows(tab.value)

                return(
                  <TabPanel key={idx} value={tab.value} >
                    <Typography variant='body2' style={{marginTop:-10, marginBottom:10}}>
                      {headerText.left} <br/>
                      {headerText.right} <br/>
                    </Typography>
                    <TableContainer style={{minHeight:'70vh', maxHeight:'100vh', overflow:'initial' }} >
                       <MUITable  style={{whiteSpace:'nowrap', top:100,  }} >
                        <MyTableHead >
                          <TableRow>
                            {
                              headRow.map((col, index) => (
                                <TableCell size='small' key={index} style={{
                                  width: 1,
                                  position:'sticky',
                                  top:50,
                                  backgroundColor:'#fafafa'
                                }}>
                                  <div dangerouslySetInnerHTML={{ __html: col }} />
                                </TableCell>
                              ))
                            }
                          </TableRow>
                        </MyTableHead>
                        <TableBody>
                          {
                            dataRows.map((row, rowIdx) => {
                              return (
                                <TableRow key={rowIdx} style={{backgroundColor: row.bing?.statCode.startsWith('X') ? '#ffebee' : null }}>
                                  {
                                    row.map((col,colIdx) =>(
                                      <TableCell size='small' key={colIdx} style={{fontFamily:'sans-serif'}} >
                                        {col}
                                      </TableCell>
                                    ))
                                  }
                                </TableRow>
                              )
                            })
                          }
                        </TableBody>
                      </MUITable>
                      <Typography variant='body2' style={{marginTop:10}}>
                        ※ 출석부 :출석○,결석X,지각△,조퇴◐,취소━,휴강D,임시공휴일H  <br />
                        ※ 결석,조퇴 사유 : 1 질병, 2 현장학습, 3 체험학습, 4 경조사, 5 가족행사, 6 미출석, 7 기타 <br />
                        {/* ※ 귀가방법(F) : 0 미정, 1 보호자 동행, 2 대리인 동행, 3 학원차 이용, 4 자율귀가 */}
                      </Typography>
                    </TableContainer>
                  </TabPanel>
                )
              })
            }
          </TabContext>
        </DialogContent>
        <DialogActions>
          <div style={{display:'flex', flex:1, flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
            <Button onClick={handleClose} style={{margin:5}}>닫기</Button>
            <Button onClick={() => onDownload(0)} variant='contained' style={{margin:5}}>출석부 다운로드</Button>
            <Button onClick={() => onDownload(1)} variant='contained' style={{margin:5}}>출석부 다운로드(결재란 있음)</Button>
            {/* <ButtonGroup */}
            {/*   orientation="vertical" */}
            {/*   aria-label="Vertical button group" */}
            {/*   variant="contained" */}
            {/* > */}
            {/*   { [ */}
            {/*     <Button onClick={() => onDownload(0)} variant='contained' style={{margin:5}}>출석부 다운로드</Button>, */}
            {/*     <Button onClick={() => onDownload(1)} variant='contained' style={{margin:5}}>출석부 다운로드(결재란 있음)</Button> */}
            {/*   ]} */}
            {/* </ButtonGroup> */}
          </div>
        </DialogActions>
      </Dialog>
      {renderIndicator()}
      {renderAlert()}
    </Fragment>

	)
}

export default TeacherAttdncPartMany
